module.exports = __webpack_public_path__ + "img/corporate-2.9dcda12a.jpg";